export const API_URL_A='https://dataapi.helpwhereyouare.com/api/v1'

export const DEFAULT_LANGUAGE = 'en'
export const FALLBACK_LANGUAGE = 'en'
export const SUPPORTED_LANGUAGES = ['en', 'bg']
export const FORM_ACTION_DOMAIN='https://www.advantageengagement.com'

export const CONTENT_DOMAIN='https://www.advantageengagement.com'

//export const RMS_DOMAIN=''
export const LOCAL_HOST=window.location.origin

export const SESSION_TIME=20; //in minutes

/*************UCMS API Details Start*************************/
export const UCMS_API_URL='https://ucmsapioffline.workplaceoptions.com'
export const UCMS_AUTHORIZATION='Token 9A514917-1EFA-442B-B6D7-D23C5438DE83'
export const UCMS_WPOSUBSCRIBER='EAP'
/*************UCMS API Details End*************************/

/**hCaptcha **/
export const HC_SITE_KEY='276beb07-dce5-4ce6-8d87-2ff5f94a0446'

/* Scheduler */
export const SCHEDULER_URL='https://helpwhereyouare.com/scheduler/whitehorse_3.0.js'

/** AuthO credentials START **/
export const AUTHO_DOMAIN='dev-d6q24cq7a1dj6zgj.us.auth0.com'//'sso.wpotest.com'//
export const AUTHO_CLIENTID='wRBbrqDFLSgeLuSsYS2SL4e3ujGWwpEX'//'5OfmGoOlfTV0dDHQuE0R3kQ8xxlRmJ7T'//
export const AUTHO_REDIRECT_URI='https://helpwhereyouare.com/ssocallback'
/** AuthO credentials END **/

/** WSO2 credentials START **/
export const WSO_CLIENTID='A2rWOzcOWIO9sG8H6BFEE3IQkkca' //prod
//'jfLxPz9P8sPGpvniwEtKV7O0uqwa' offline/sandbox
//'Fe5BYB2CjybYdr1zuBdQK9t38esa'//'5OfmGoOlfTV0dDHQuE0R3kQ8xxlRmJ7T'// test
export const WSO_BASEURL='https://api.asgardeo.io/t/workplaceoptions'
//'https://api.asgardeo.io/t/wposandbox' //'https://api.asgardeo.io/t/testwpo'
/** WSO2 credentials END **/


/*****WEGLOT START  */
export const weglot_ary = {"040": 'sv', "047": 'he', "041": 'no', "031": 'tl', "027": 'ro', "032": 'uk', "035": 'id', "009": 'th', "016": 'da', "011": 'vi',"018": 'fi'}
/*****WEGLOT END */

/* RTL languages START*/
export const RTL_LANG=['043','047','177']
/* RTL languages END*/

/* ExpHub START */
export const EXP_HUB_API="https://dataapi.helpwhereyouare.com/api/exphubv1";
/* ExpHub END */